<template>
  <div class="procedure-report-summary-cards">
    <v-card
      v-for="card in cards"
      :key="card.key"
      class="procedure-report-summary-card"
      :class="{
        'procedure-report-summary-card--active': activeCard === card.key,
        'procedure-report-summary-card--inactive': activeCard && activeCard !== card.key,
      }"
      elevation="4"
      @click="onCardClick(card.key)">
      <v-skeleton-loader
        v-if="loading"
        class="fill-width"
        type="list-item-avatar-two-line"
      />

      <template v-else>
        <v-avatar
          class="procedure-report-summary-card__icon"
          size="36"
          :color="activeCard && activeCard !== card.key ? '#BDBDBD' : card.color">
          <v-icon color="white" size="20">
            {{ card.icon }}
          </v-icon>
        </v-avatar>

        <div class="procedure-report-summary-card__content">
          <div class="procedure-report-summary-card__numbers">
            <span class="procedure-report-summary-card__value">
              {{ formatValue(card.value) }}
            </span>
            <span
              class="procedure-report-summary-card__percentage"
              :style="{ color: activeCard && activeCard !== card.key ? '#BDBDBD' : card.color }">
              {{ card.percentage }}
            </span>
          </div>

          <span class="procedure-report-summary-card__label">
            {{ card.label }}
          </span>
        </div>
      </template>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'ProcedureReportSummaryCards',
  props: {
    cards: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    activeCard: {
      type: String,
      default: null,
    },
  },
  methods: {
    onCardClick(key) {
      this.$emit('card-click', key);
    },
    formatValue(value) {
      const numericValue = Number(value);
      if (Number.isNaN(numericValue)) return value;
      return new Intl.NumberFormat('pt-BR').format(numericValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.procedure-report-summary-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.procedure-report-summary-card {
  align-items: center;
  border-radius: 6px !important;
  cursor: pointer;
  display: flex;
  height: 56px;
  overflow: hidden;
  padding: 0 12px;
  transition: opacity 0.2s ease;
  width: 300px;

  &--inactive {
    opacity: 0.4;
  }

  &__icon {
    flex-shrink: 0;
    margin-right: 12px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__numbers {
    align-items: baseline;
    display: flex;
    gap: 12px;
    height: 24px;
  }

  &__value {
    color: var(--v-foreground-base);
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
  }

  &__percentage {
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
  }

  &__label {
    color: color-mix(in srgb, var(--v-foreground-base) 60%, transparent);
    font-size: 14px;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
